import React from 'react';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { UserProfileBreadcrumb } from '../../components/users/UserProfileBreadcrumb';
import { UserSidebarMenu } from '../../components/users/UserSidebarMenu';
import { UserProfileCard } from '../../components/users/UserProfileCard';

export const UserProfilePage = () => {
    useDocumentTitle('Profile');

    return (
        <div className="user-profile-page mb-5">
            <h1 className="h3">Profile</h1>
            <UserProfileBreadcrumb />
            <div className="row">
                <div className="col-sm-4 col-md-4 col-lg-3 mb-3">
                    <UserSidebarMenu />
                </div>
                <div className="col-sm-8 col-md-8 col-lg-9 mb-3">
                    <UserProfileCard />
                </div>
            </div>
        </div>
    );
};
